export const tempOrdersErrorCodes = {
  outOfStock: ["E00949"], //庫存不足
  couponErrors: [
    "E00974", //Coupon code 活動結束
    "E00950", //Coupon 不存在
    "E00980", //剩餘 Quota 不足
    "E00981", //couoonId 重複
    "E00982", //其他 coupon errors
  ],
};
